module.exports = __webpack_public_path__ + "static/media/time_active.413f0712.svg";